import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDescontoCupomPlanoSelecionadoMatricula = (): TabelaColuna => ({
  Chave: 'DescontoCupomPlanoSelecionadoMatricula',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 250 }}>Desconto Cupom Plano Selecionado Matrícula</div>
  )
})
